import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useBalanceReportFilterFields } from './hooks/useBalanceReportFilterFields';

export const BalanceReportListFilterChips: React.FC = () => {
  const fields = useBalanceReportFilterFields();

  return <FilterChips fields={fields} />;
};
